import React from 'react'
import './AboutUsHeroSection.component.scss'

const AboutUsHeroSection = () => {
  return (
    <section className='about-us-hero-section'>
      <div className='about-us-hero-section__inner'>
        <h1 className='about-us-hero-section__headline'>
          <span>About USA Benefits Group</span>
        </h1>

        <p className='about-us-hero-section__subtitle'>
          <span>
            USA Benefits Group is a nationwide network of licensed insurance professionals dedicated to helping clients
            navigate health, Medicare, life, and supplemental coverage with clarity and confidence.
          </span>
        </p>
      </div>
    </section>
  )
}

export default AboutUsHeroSection
